export default "__VITE_ASSET__4db7859d__"